module.exports = __webpack_public_path__ + "media/bootstrap-icons/patch-exclamation-32d00638.svg";